export default __webpack_public_path__ + "static/media/CourseThumbnail-Sculpture01.1094b1fc.png";